import type { Translation } from "../i18n-types.js"

const it = {
  common: {
    countViews: "{{nessuna visualizzazione|1 visualizzazione|?? visualizzazioni}}",
    countReactions: "{{nessuna reazione|1 reazione|?? reazioni}}",
    back: "Indietro",
    blog: "Post",
    settings: "Impostazioni",
    addPosts: "crea post",
    save: "Salva",
    filter: "Filtra",
    tag: "Tag",
    sort: "Ordina",
    all: "Tutti",
    loading: "Caricamento...",
    saving: "Salvataggio...",
    delete: "Elimina",
    edit: "Modifica",
    close: "Chiudi",
    error: "Errore nel salvare i dati",
    networkError: "Errore nel salvare i dati. Controlla la connessione",
    validationError: "Controlla il modulo per errori",
    by: "di",
    cancel: "Annulla",
    private: "Privato",
    holdToConfirm: "Tieni premuto",
    done: "Fatto!",
    defaultLanguage: "predefinita",
    translating: "Traduzione in corso...",
    translateAll: "Traduci tutto",
    translateFrom: "Traduci da {language}",
  },
  mainLayout: {
    errorLoadingData: "Si è verificato un errore nel caricamento dei dati per questa pagina. Riprova.",
    reloadPage: "Ricarica la pagina",
  },
  dashboard: {
    welcomeBack: "Bentornato",
    latestPosts: "Ultimi post",
    viewAllPosts: "Vedi tutti i post",
    noPostsYet: "Non hai ancora pubblicato nessun post.",
    latestDrafts: "Ultime bozze",
    viewAllDrafts: "Vedi tutto",
    noDrafts: "Non hai bozze",
    latestNotes: "Ultime note",
    noNotesYet: "Non hai ancora nessuna nota",
    subscribers: "Iscritti",
    posts: "Post",
    views: "Visualizzazioni",
    openRate: "Tasso di apertura",
    published: "Pubblicato",
    created: "Creato",
    recentReactions: "Reazioni recenti",
    noReactionsYet: "Non hai ancora reazioni",
    reactedToYourPost: "hanno reagito al tuo post",
    othersCount: "{{nessun'altra|1 altra persona|?? altre persone}}",
    createPublication: {
      title: "Crea la tua pubblicazione",
      description: "Inizia il tuo angolo sul web. condividi i tuoi pensieri, costruisci il tuo pubblico e possiedi i tuoi contenuti.",
      button: "Inizia",
    },
    verifyEmail: {
      title: "Verifica la tua email",
      description: "Verifica il tuo indirizzo email per sbloccare tutte le funzionalità, come la creazione della tua pubblicazione.",
      button: "Verifica email",
    },
  },
  settings: {
    title: "Impostazioni",
    localizationTitle: "Lingua",
    localizationDescription: "Scegli la tua lingua preferita",
    interfaceLanguageLabel: "Lingua dell'interfaccia",
    authenticationTitle: "Autenticazione",
    authenticationDescription: "Gestisci il tuo account",
    signedInAs: "Connesso come {email}",
    signOut: "Esci",
    signingOut: "Uscita in corso...",
    authorProfileTitle: "Profilo autore",
    authorProfileDescription: "Informazioni su di te che verranno mostrate nella tua pubblicazione",
    profileImageLabel: "Foto di profilo (120×120)",
    authorNameLabel: "Nome autore",
    authorNamePlaceholder: "Il tuo nome",
    bioLabel: "Bio",
    bioPlaceholder: "Racconta ai tuoi lettori di te",
    imageSaved: "Immagine caricata",
    imageDeleted: "Immagine eliminata",
    informationSaved: "Salvato con successo",
    social: {
      title: "social network",
      description: "collega i tuoi profili social alla tua pubblicazione",
      social_x: {
        label: "X (Twitter)",
        placeholder: "https://x.com/nomeutente",
      },
      social_instagram: {
        label: "Instagram",
        placeholder: "https://instagram.com/nomeutente",
      },
      social_tiktok: {
        label: "TikTok",
        placeholder: "https://tiktok.com/@nomeutente",
      },
      social_youtube: {
        label: "YouTube",
        placeholder: "https://youtube.com/@nomeutente",
      },
      social_facebook: {
        label: "Facebook",
        placeholder: "https://facebook.com/nomeutente",
      },
      social_linkedin: {
        label: "LinkedIn",
        placeholder: "https://linkedin.com/in/nomeutente",
      },
      social_bluesky: {
        label: "Bluesky",
        placeholder: "https://bsky.app/profile/nomeutente",
      },
      social_books: {
        label: "Libri",
        placeholder: "https://goodreads.com/user/show/nomeutente",
      },
      social_website: {
        label: "Sito web",
        placeholder: "https://iltuosito.com",
      },
      social_soundcloud: {
        label: "SoundCloud",
        placeholder: "https://soundcloud.com/nomeutente",
      },
      social_bandcamp: {
        label: "Bandcamp",
        placeholder: "https://nomeutente.bandcamp.com",
      },
    },
    subscriptions: {
      empty: "Non hai ancora iscrizioni",
      unsubscribeTitle: "Disiscriviti",
      unsubscribeDescription: "Non riceverai più aggiornamenti da questa pubblicazione.",
      unsubscribePaidDisclaimer: "Anche il tuo piano a pagamento attuale verrà annullato.",
      holdToUnsubscribe: "Tieni per disiscriverti",
      unsubscribing: "Disiscrizione...",
      unsubscribed: "Disiscritto",
    },
    deleteAccount: {
      title: "Elimina account",
      description: "Elimina permanentemente il tuo account e tutti i dati",
      warning: "Questa azione non può essere annullata. Tutti i post, le note e i dati degli abbonati saranno eliminati permanentemente.",
      button: "Elimina account",
      confirmTitle: "Eliminare il tuo account?",
      confirmDescription: "Questo eliminerà permanentemente il tuo account e tutto il contenuto. Questa azione non può essere annullata.",
      exportBeforeDeletePrefix: "Prima di eliminare, puoi",
      exportBeforeDeleteSuffix: "i dati della tua pubblicazione, inclusi tutti i post, le note e le informazioni degli abbonati.",
      typeToConfirm: "Digita {text} per confermare",
      confirmButton: "Elimina il mio account",
    },
  },
  post: {
    preview: "anteprima",
    previewDescription: "Vedi come apparirebbe il tuo post ai tuoi lettori.",
    unarchive: "ripristina",
    update: "aggiorna",
    updated: "Post aggiornato con successo",
    publish: "Continua",
    uploadHeaderImage: "Carica immagini di intestazione (16:9, 800 × 450 px)",
    title: "Titolo",
    subtitle: "Sottotitolo",
    statusSpam: "Questa versione è stata contrassegnata come spam. Contatta il supporto se pensi sia un errore.",
    statusArchived: "Questa versione è archiviata; non è visibile agli altri, ma puoi ancora modificarla.",
    statusSent: "Questa versione è stata inviata ai tuoi iscritti via email",
    statusPublished: "Questa versione è pubblicata e visibile ai tuoi lettori",
    statusDraft: "Questa è una bozza; puoi visualizzarne l'anteprima ma non è pubblica",
    words: "parole",
    savedAt: "Salvato alle {time}",
    notes: "Note",
    notesDescription: "Crea e fissa note a questo post.",
    proofread: "Revisione",
    proofreadDescription: "Ottieni aiuto per migliorare la chiarezza e il coinvolgimento del tuo post.",
    versions: "Versioni",
    settings: "Impostazioni",
    settingsDescription: "Configura il tuo post.",
    translations: "Traduzioni",
    alsoIn: "Anche in",
    translationsDescription: "Traduci automaticamente il tuo post in altre lingue. Raggiungi più lettori.",
    share: "Condividi",
    shareDescription: "Ottieni un link per condividere il tuo post sui social media.",
    focusMode: "Modalità concentrazione",
    focusModeDescription: "Trasforma l'editor in una modalità senza distrazioni per concentrarti sulla tua scrittura.",
    translationOutdated: "Questa traduzione è stata fatta per una versione precedente",
    mainLanguage: "Lingua principale",
    alternativeLanguages: "Lingue alternative",
    alternativeLanguagesDescription: "Abilita le traduzioni per il tuo post. Attiva le lingue per generarli o disattivale per rimuoverli.",
    translationsSaved: "Traduzioni salvate con successo",
    translationOutdatedMessage: "Questa traduzione è obsoleta.",
    translationUpToDate: "Questa traduzione è aggiornata.",
    regenerateTranslation: "Aggiornarla",
    translationOutdatedOr: "O",
    markTranslationAsUpdated: "Segna come aggiornata",
    updatingTranslation: "Aggiornamento traduzione...",
    translationRegenerated: "Traduzione aggiornata con successo",
    saveChanges: "Salva modifiche",
    saveAndGenerate: "Salva e genera",
    saveAndDelete: "Salva ed elimina",
    publishPage: {
      update: "Aggiorna",
      publish: "Pubblica",
      delivery: "Consegna",
      deliveryDescription: "Come vuoi consegnare questo post?",
      sendViaEmail: "Invia via email",
      alreadySent: "Hai già inviato questo post ai tuoi iscritti via email il {date}",
      subscribersWillReceive: "{{Nessun iscritto|1 iscritto|?? iscritti}} riceveranno questo post nella loro casella di posta.",
      sendTestToMyself: "Invia test a me stesso",
      testEmailSent: "Email di test inviata con successo",
      testEmailError: "Errore nell'invio dell'email di test",
      audienceTitle: "Pubblico",
      audienceDescription: "Scegli chi può visualizzare questo post.",
    },
  },
  editor: {
    defaultPlaceholder: "Scrivi qualcosa…",
    highlightColor: "Colore evidenziazione",
    noHighlight: "Nessuna evidenziazione",
    grey: "Grigio",
    yellow: "Giallo",
    blue: "Blu",
    green: "Verde",
    orange: "Arancione",
    red: "Rosso",
    bulletList: "Elenco puntato",
    orderedList: "Elenco numerato",
    image: "Immagine",
    code: "Codice",
    quote: "Citazione",
    subscribe: "Iscriviti",
    imageTitlePlaceholder: "Titolo dell'immagine",
    imageDescriptionPlaceholder: "Descrizione per accessibilità",
    imageSizeSmall: "Piccolo",
    imageSizeMedium: "Medio",
    imageSizeBig: "Larghezza intera",
    turnIntoLabel: "Trasforma in...",
    heading1: "Titolo 1",
    heading2: "Titolo 2",
    heading3: "Titolo 3",
    blockquote: "Citazione",
    text: "Testo",
    callout: "Evidenziazione",
    bold: "Grassetto",
    italic: "Corsivo",
    strikethrough: "Barrato",
    inlineCode: "Codice in linea",
    highlight: "Evidenziazione",
    link: "Link",
    horizontalRule: "Divisore",
    undo: "Annulla",
    redo: "Ripristina",
    insertBlock: "Inserisci blocco",
    more: "Altro",
    snippet: "Snippet",
    codeBlock: "Blocco di codice",
    math: "Math",
    embed: "Embed",
    embedDisplay: "Visualizzazione",
    embedDisplayEmbed: "Interattivo",
    embedDisplayCard: "Scheda",
    language: "Lingua",
  },
  notes: {
    newNote: "Nuova nota",
    cancel: "annulla",
    noPinnedYet: "nessuna nota",
    voice: "voce",
    copyToPost: "copia nell'articolo",
  },
  blog: {
    title: "Pubblicazione",
    audience: "Pubblico",
    forms: "Forms",
    stats: "Statistiche",
    noResultsFound: "Nessun risultato trovato",
    noPostsYet: "Non hai ancora creato nessun post.",
    filter: {
      spam: "Spam",
      archived: "Archiviato",
      sent: "Inviato",
      published: "Pubblicato",
      draft: "Bozza",
    },
    blogName: "Nome della pubblicazione",
    blogNameDescription: "Imposta il nome della tua pubblicazione: verrà usato per identificare la pubblicazione e generare l'URL",
    atLeast3Characters: "Da 3 a 15 caratteri: lettere, numeri o trattini.",
    nameAvailable: "Questo nome è disponibile.",
    nameInvalid: "Questo nome non è valido.",
    nameUnavailable: "Questo nome è già in uso.",
    nameNaughty: "Questo nome non è consentito.",
    nameChangeCooldown: "Potrai cambiare il tuo nome tra {days} {{giorno|giorni}}.",
    nameChangeWarning: "Dopo la modifica, non potrai cambiare il nome per 30 giorni. Il tuo vecchio indirizzo reindirizzerà al nuovo.",
    checkingNameAvailability: "Verifica disponibilità del nome...",
    language: "Lingua",
    languageDescription: "Imposta la lingua della tua pubblicazione",
    additionalLanguages: "Lingue aggiuntive",
    additionalLanguagesDescription: "Scegli quali lingue sono disponibili per le traduzioni nella tua pubblicazione. Tutte le lingue sono abilitate per impostazione predefinita.",
    titleAndDescription: "Titolo e descrizione",
    titleAndDescriptionDescription: "Imposta il titolo e la descrizione del tuo spazio",
    yourBlogTitle: "titolo-della-pubblicazione",
    description: "Descrizione",
    yourBlogDescription: "descrizione-della-pubblicazione",
    branding: "Branding",
    brandingDescription: "Aggiungi il tuo branding personalizzato alla pubblicazione e alle email",
    logo: "Logo",
    logoDescription: "Verrà mostrato in cima alla pubblicazione e nelle email. Dimensioni consigliate: 200 × 200 px.",
    uploadLogo: "Carica logo",
    wordmark: "Wordmark",
    wordmarkDescription: "Verrà mostrato al posto del nome della pubblicazione in cima alla pagina. Dimensioni consigliate: 1000 × 200 px.",
    uploadWordmark: "Carica wordmark",
    subscribeImage: "Immagine iscrizione",
    subscribeImageDescription: "Verrà mostrata nel modulo di iscrizione. Dimensioni consigliate: 600 × 600 px.",
    uploadSubscribeImage: "Carica immagine iscrizione",
    favicon: "Favicon",
    faviconDescription: "Verrà mostrata come icona della scheda del browser per la tua pubblicazione. Dimensioni consigliate: 128 × 128 px.",
    uploadFavicon: "Carica favicon",
    header: "Header",
    headerDescription: "Aggiungi un header personalizzato a ciascun post",
    footer: "Footer",
    footerDescription: "Aggiungi un footer personalizzato a ciascun post",
    welcomeEmail: {
      title: "Email di benvenuto",
      description: "Personalizza l'email di benvenuto inviata ai nuovi abbonati",
      subjectLabel: "Oggetto dell'email",
      subjectContent: "Contenuto dell'email",
    },
    export: {
      title: "Esporta",
      description: "Esporta tutti gli abbonati e i contenuti della tua pubblicazione",
      generateExport: "Genera esportazione",
      generating: "Generazione...",
      exportedAt: "Esportato il",
      subscribers: "Abbonati",
      posts: "Pubblicazioni",
      download: "Scarica",
      processing: "Elaborazione...",
      error: "Errore",
      noExports: "Nessuna esportazione",
    },
    subscribersPage: {
      email: "Email",
      subscribedAt: "Iscritto il",
      tier: "Livello",
      form: "Form",
      allForms: "All forms",
      direct: "Direct",
      free: "Gratuito",
      allTiers: "Tutti i livelli",
      noSubscribersFound: "Nessun iscritto trovato",
      noSubscribersYet: "Nessun iscritto ancora",
      publication: "Pubblicazione",
      followBack: "Iscriviti",
      following: "Iscritto",
    },
    formsPage: {
      editorTitle: "Create form",
      editEditorTitle: "Edit form",
      createForm: "Create form",
      editForm: "Edit form",
      name: "Name",
      audience: "Destinatari",
      audienceDescription: "Scegli chi può ricevere l'email con i file. Se limiti l'accesso, dovranno prima iscriversi o passare a un livello superiore.",
      downloads: "Files",
      subscribers: "Subscribers",
      size: "Size",
      actions: "Actions",
      everyone: "Tutti",
      everyoneDescription: "Chiunque può inviare il modulo e ricevere l'email con i file.",
      subscribersOnly: "Solo iscritti",
      subscribersOnlyDescription: "Solo gli iscritti possono ricevere l'email con i file.",
      content: "Description",
      email: "Email",
      emailSubject: "Email subject",
      emailBody: "Email body",
      formSectionTitle: "Create form",
      formSectionDescription: "Set up your form and file delivery",
      filesSectionTitle: "Files",
      filesSectionDescription: "Upload the files readers will receive",
      emailSectionDescription: "Customize the delivery email sent after submit",
      defaultDescription: "Iscriviti per ricevere questi file via email.",
      defaultEmailSubject: "I tuoi file sono pronti",
      defaultEmailSubjectWithName: "{publicationName}: i tuoi file sono pronti",
      defaultEmailGreeting: "Ciao,",
      defaultEmailIntro: "grazie per esserti iscritto. I link per il download sono qui sotto.",
      defaultEmailOutro: "Se hai domande, rispondi semplicemente a questa email.",
      defaultEmailSignature: "- Il team",
      defaultEmailSignatureWithName: "- {publicationName}",
      dropFiles: "Drop the files",
      formCreated: "Form created",
      formUpdated: "Form updated",
      formDeleted: "Form deleted",
      blankSlate: {
        title: "Capture, nurture, convert",
        growReadership: "Grow your readership",
        growReadershipDescription: "Capture more readers by offering exclusive content behind a subscription form.",
        convertReaders: "Convert readers into paid subscribers",
        convertReadersDescription: "Offer useful downloads and resources that turn readers into subscribers.",
        goBeyondText: "Go beyond text",
        goBeyondTextDescription: "Give your audience more by supplementing your written content with downloadable media and resources.",
      },
    },
    reactionEmojis: "Emoji di reazione",
    reactionEmojisDescription: "Scegli quali emoji i lettori possono usare per reagire ai tuoi articoli",
    addEmoji: "Aggiungi emoji",
    interval: "intervallo",
    referrer: "referrer",
    visitors: "visitatori",
    views: "visualizzazioni",
    country: "paese",
    channel: "canale",
  },
  categories: {
    culture: "Cultura",
    technology: "Tecnologia",
    business: "Business",
    usPolitics: "Politica USA",
    finance: "Finanza",
    food: "Cibo",
    podcast: "Podcast",
    sports: "Sport",
    art: "Arte",
    worldPolitics: "Politica Mondiale",
    healthPolitics: "Politica Sanitaria",
    news: "Notizie",
    fashionBeauty: "Moda & Bellezza",
    music: "Musica",
    faith: "Fede",
    climate: "Clima",
    science: "Scienza",
    literature: "Letteratura",
    fiction: "Narrativa",
    health: "Salute",
    design: "Design",
    travel: "Viaggi",
    parenting: "Genitorialità",
    philosophy: "Filosofia",
    comics: "Fumetti",
    international: "Internazionale",
    crypto: "Cripto",
    history: "Storia",
    humor: "Umorismo",
    education: "Istruzione",
    filmTv: "Cinema & TV",
  },
  readerOnboarding: {
    subscribedTo: "Ti sei iscritto a \"{publicationTitle}\"",
    selectInterests: "Quali argomenti ti interessano?",
    selectInterestsDescription: "Seleziona le categorie che vorresti leggere. Questo ci aiuta a consigliarti pubblicazioni che ti piaceranno.",
    continue: "Continua",
    skip: "Salta per ora",
  },
  onboarding: {
    buildAudience: "Costruisci il tuo pubblico alle tue condizioni",
    ownYourContent: "Su Fika sei proprietario di ciò che scrivi e della comunità che si crea attorno.",
    nameYourBlog: "Inizia dando un nome alla tua pubblicazione; il tuo angolo personale nel vasto web aperto.",
    yourBlogNamePlaceholder: "nome-della-pubblicazione",
    createBlog: "Crea pubblicazione",
    continue: "Continua",
    updateBlog: "Aggiorna pubblicazione",
    onboardingRabbitAlt: "Coniglio di onboarding",
    chooseLanguage: {
      title: "In quali lingue scriverai?",
      description: "Scegli la lingua della tua pubblicazione e abilita quelle aggiuntive per le traduzioni.",
    },
    createFirstPost: {
      title: "Pubblica il tuo primo articolo",
      description: "Inizia a scrivere il tuo primo articolo e inizia con Fika. Condividi i tuoi pensieri con il mondo!",
      descriptionWithDraft: "Continua a scrivere il tuo primo articolo e inizia con Fika. Condividi i tuoi pensieri con il mondo!",
      ignore: "Ignora",
      createPost: "Crea articolo",
      continueWriting: "Continua a scrivere",
    },
    createSecondPost: {
      title: "Pubblica il tuo secondo articolo",
      description: "Scrivi un altro articolo e condividilo con i tuoi lettori.",
      descriptionWithDraft: "Continua a scrivere il tuo secondo articolo.",
      ignore: "Ignora",
      createPost: "Crea articolo",
      continueWriting: "Continua a scrivere",
      creating: "Creazione...",
    },
    fillProfile: {
      title: "Completa il tuo profilo",
      description: "Aggiungi il tuo nome, biografia e immagine del profilo per personalizzare la tua presenza su Fika.",
      ignore: "Ignora",
      editProfile: "Modifica profilo",
    },
    setLanguage: {
      title: "Imposta la lingua della tua pubblicazione",
      description: "Scegli la lingua principale della tua pubblicazione. Questo aiuta i lettori a trovare i tuoi contenuti.",
      ignore: "Ignora",
      chooseLanguage: "Scegli lingua",
    },
    fillPublication: {
      title: "Aggiungi dettagli della pubblicazione",
      description: "Dai un titolo, una descrizione e un logo alla tua pubblicazione per farla risaltare.",
      ignore: "Ignora",
      editDetails: "Modifica dettagli",
    },
    translateArticles: {
      title: "Traduci \"{title}\"",
      description: "Aggiungi traduzioni ai tuoi articoli per raggiungere lettori in diverse lingue.",
      ignore: "Ignora",
      translateLatestArticle: "Traduci articolo",
    },
  },
  postSettings: {
    title: "impostazioni",
    customPagesTitle: "pagine personalizzate",
    customPagesDescription: "fai apparire questo post nella barra di navigazione",
    customPageLabel: "pagina personalizzata",
    seoMetadataTitle: "metadati seo",
    seoMetadataDescription: "il titolo e la descrizione del post come appariranno nei risultati di ricerca",
    seoMetadataSaved: "metadati salvati",
    metaTitleLabel: "meta titolo",
    metaTitlePlaceholder: "titolo della tua pubblicazione",
    metaDescriptionLabel: "meta descrizione",
    metaDescriptionPlaceholder: "descrizione della tua pubblicazione",
    canonicalTitle: "canonico",
    canonicalDescription: "se la fonte originale del post è un altro sito web, puoi specificare l'URL canonico qui per evitare problemi di contenuto duplicato.",
    canonicalUrlLabel: "url canonico",
    canonicalUrlSaved: "url canonico salvato",
    pinSaved: "pagina personalizzata salvata",
    tagsTitle: "tag",
    tagsDescription: "aggiungi tag al tuo post",
    audienceSaved: "impostazioni pubblico salvate",
    audienceTitle: "Pubblico",
    audienceDescription: "Scegli chi può accedere a questo post.",
    audienceEveryoneLabel: "Tutti",
    audienceEveryoneDescription: "Chiunque può visualizzare, inclusi i visitatori non abbonati.",
    audienceAllSubscribersLabel: "Solo abbonati",
    audienceAllSubscribersDescription: "Qualsiasi abbonato può vedere questo post.",
    commentsEnabledTitle: "Comments",
    commentsEnabledDescription: "Allow readers to comment on this post.",
    publishedAtTitle: "data di pubblicazione",
    publishedAtDescription: "modifica la data di prima pubblicazione di questo post.",
    publishedAtLabel: "data di pubblicazione",
    publishedAtSaved: "data di pubblicazione salvata",
    archivePostTitle: "archivia post",
    unarchivePostTitle: "ripristina post",
    archivePostDescription: "nascondi questo post dalla tua pubblicazione.",
    unarchivePostDescription: "mostra questo post nella tua pubblicazione.",
    archivePostSaved: "post archiviato",
    deletePostTitle: "elimina post",
    deletePostDescription: "rimuovi questo post completamente.",
    deletePostWarning: "questa azione non può essere annullata.",
    deletePostSaved: "post eliminato",
    holdToDelete: "Tieni per eliminare",
    deleting: "Eliminazione...",
    deleted: "Eliminato!",
  },
  postShare: {
    preview: "Anteprima",
    previewDescription: "Come apparirà il tuo post sui social media e nei risultati di ricerca",
    articleLink: "Link dell'articolo",
    copyLink: "Copia link",
    linkCopied: "Link copiato negli appunti",
    metaTitleLabel: "Meta titolo",
    metaTitlePlaceholder: "Il titolo della tua pubblicazione",
    metaDescriptionLabel: "Meta descrizione",
    metaDescriptionPlaceholder: "La descrizione della tua pubblicazione",
    shareOnSocialMedia: "Condividi sui social media",
    shareOn: "Condividi su {network}",
    publishedCongrats: "Il tuo post è online!",
    shareNow: "Ora condividilo con il mondo! 🚀",
    backToPost: "Torna al post",
    setCoverImage: "Imposta come copertina",
    resetCoverImage: "Ripristina all'originale",
    coverImageUpdated: "Immagine di copertina aggiornata",
    socialImages: "Immagini per i social",
    socialImagesDescription: "Scarica immagini per i social media",
    download: "Scarica",
  },
  postVersions: {
    title: "versioni",
    loading: "caricamento versioni...",
    failed: "impossibile caricare le versioni",
    failedVersion: "impossibile caricare la versione",
    restored: "versione ripristinata con successo",
    restore: "ripristina",
    language: "lingua",
    pills: {
      current: "attuale",
      archived: "archiviata",
      sent: "inviata",
      published: "pubblicata",
    },
  },
  subscribe: {
    defaultText: "Iscriviti a {userName} per ricevere aggiornamenti direttamente nella tua casella di posta",
    button: "Iscriviti",
    emailPlaceholder: "Inserisci la tua email",
  },
  snippet: {
    placeholder: "Descrivi cosa vuoi creare...",
    placeholderUpdate: "Descrivi cosa vuoi cambiare...",
    buttonCreate: "crea",
    buttonUpdate: "aggiorna",
    buttonCreating: "Creazione...",
    buttonUpdating: "Aggiornamento...",
  },
  auth: {
    signInOrSignUp: "Accedi",
    registrationsClosed: "Le registrazioni sono chiuse. Gli utenti esistenti possono accedere.",
    accountSuspendedTitle: "Account sospeso",
    accountSuspendedMessage: "Il tuo account è stato sospeso. Contatta humans@fika.bar se pensi che sia un errore.",
    continueWithGoogle: "Continua con Google",
    continueWithLinkedIn: "Continua con LinkedIn",
    signingIn: "Accesso...",
    or: "oppure",
    enterYourEmail: "Inserisci la tua email",
    failedToSend: "Impossibile inviare il codice di verifica. Riprova.",
    sending: "Invio...",
    enterCode: "Inserisci il codice a 6 cifre che è stato inviato a",
    verifying: "Verifica in corso...",
    invalidCode: "Codice non valido o scaduto. Riprova.",
    useDifferentEmail: "Usa un'altra email",
    subscribeTo: "Iscriviti a",
    thisBlog: "questa pubblicazione",
    getUpdates: "Iscriviti per ricevere aggiornamenti nella tua casella di posta",
    subscribe: "Iscriviti",
    somethingWentWrong: "Qualcosa è andato storto",
    disclaimerPrefix: "Inviando, accetti la",
    disclaimerPrivacy: "privacy policy",
    disclaimerAnd: "e i",
    disclaimerTerms: "termini di servizio",
    tierSelectionTitleSubscribed: "Sei iscritto a {publicationName}!",
    tierSelectionTitleSubscribedNoName: "Sei iscritto!",
    subscriptionError: "Si è verificato un errore. Riprova.",
    verifyEmailSuccess: "Email verificata con successo!",
    emailNotVerified: "Verifica la tua email per eseguire questa azione",
    subscriptionConfirmationDescriptionBeforeAuthor: "Riceverai aggiornamenti da ",
    subscriptionConfirmationDescriptionAfterAuthor: " direttamente nella tua casella di posta.",
    subscriptionConfirmationDescriptionNoAuthor: "Riceverai aggiornamenti direttamente nella tua casella di posta.",
  },
  unsubscribe: {
    writerSuccess: "ti sei disiscritto",
    writerSuccessDescription: "non riceverai più email da questo autore. puoi sempre iscriverti nuovamente dal suo profilo.",
    marketingSuccess: "ti sei disiscritto",
    marketingSuccessDescription: "non riceverai più email promozionali da fika. puoi gestire le tue preferenze nelle impostazioni.",
    weeklyFeaturedSuccess: "ti sei disiscritto",
    weeklyFeaturedSuccessDescription: "non riceverai più l'email settimanale degli articoli in evidenza. puoi riattivarlo nelle impostazioni.",
    error: "qualcosa è andato storto",
    invalidToken: "questo link di disiscrizione non è valido o è scaduto. riprova da un'email recente.",
    missingToken: "nessun token di disiscrizione fornito. utilizza il link dalla tua email.",
    genericError: "si è verificato un errore imprevisto. riprova più tardi.",
    invalidRequest: "richiesta non valida",
    invalidRequestDescription: "questa pagina richiede un link di disiscrizione valido da un'email.",
    signInToManage: "accedi per gestire le iscrizioni",
  },
  subscriptions: {
    title: "Iscrizioni",
    manage: "Gestisci",
    manageTitle: "Gestisci iscrizioni",
    viewOriginal: "Vedi originale",
    noPublishedPostsYet: "Nessun post pubblicato ancora",
    previousPost: "Articolo precedente",
    nextPost: "Articolo successivo",
    following: "Seguendo",
    subscribed: "Iscritto",
    renewsAt: "Si rinnova il {date}",
    upgradePlan: "Passa a premium",
    tierChangeError: "Impossibile cambiare piano",
    manageBilling: "Fatturazione e ricevute",
    subscribersOnly: "Solo abbonati",
    tableOfContents: "Indice dei contenuti",
  },
  discover: {
    readMore: "Leggi di più",
    upgradeToRead: "Aggiorna per leggere",
    humanContent: "Umano",
    humanContentTitle: "Contenuto umano",
    humanContentDescription: "Fika è altamente fiducioso che questo contenuto sia stato scritto da un essere umano con poca o nessuna assistenza dell'IA.",
  },
  privatePost: {
    subscribeCta: "Iscriviti",
    upgradeCta: "Aggiorna per sbloccare",
  },
  applicationLayout: {
    loadingPhrases: {
      synchronizing: "sincronizzazione...",
      hadronCollider: "assemblaggio del collisore di adroni...",
      reticulatingSplines: "reticolazione degli splines...",
      wakingHamsters: "svegliando i criceti...",
      consultingOracle: "consultando l'oracolo...",
      aligningStars: "allineamento delle stelle...",
      fluxCapacitor: "calibrazione del condensatore di flusso...",
      traveling88mph: "viaggiando a 88 mph...",
      whiteRabbit: "seguendo il coniglio bianco...",
      reversingPolarity: "inversione della polarità...",
      enhancingImage: "miglioramento dell'immagine...",
      enteringMatrix: "entrando nella matrice...",
      findingRing: "trovando l'unico anello...",
      dividingByZero: "dividendo per zero...",
    },
  },
  proofreader: {
    title: "Correttore",
    editorTitle: "Editor",
    editorDescription: "Rileggi il tuo articolo per migliorare chiarezza e impatto.",
    principles: {
      grammar: {
        label: "Grammatica",
        description: "Correggi errori ortografici e grammaticali.",
        action: "Correggi grammatica",
      },
      tighten: {
        label: "Condensare",
        description: "Rendi il testo più conciso.",
        action: "Condensa testo",
      },
      refine: {
        label: "Affinare",
        description: "Migliora chiarezza, fluidità e impatto del testo.",
        action: "Affina testo",
      },
    },
    noFixesFound: "Nessuna correzione trovata",
    countFixes: "{{Nessuna correzione|1 correzione|?? correzioni}}",
    countFixesFound: "{{Nessuna correzione trovata|1 correzione trovata|?? correzioni trovate}}",
    scanning: "Scansione...",
    percentComplete: "{percent}% completato",
    discard: "Annulla",
    acceptAll: "Accetta tutto",
    lenses: {
      title: "Lenti",
      description: "Visualizza la struttura delle frasi per migliorare ritmo e leggibilità.",
      off: "spento",
      difficulty: "difficoltà",
      difficultyDescription: "Mostra quanto sono difficili le tue frasi. Le frasi più difficili appaiono in colori più caldi. Per migliorare, usa frasi più corte e parole più semplici.",
      variation: "variazione",
      variationDescription: "Mostra quanto sono variate le lunghezze delle tue frasi. Le frasi monotone appaiono in colori più caldi. Per migliorare, usa un mix di frasi corte e lunghe.",
      legend: {
        difficulty: {
          orange: "Molto difficile da leggere",
          amber: "Difficile da leggere",
        },
        variation: {
          orange: "Molto monotona",
          amber: "Monotona",
        },
      },
      tips: {
        veryHard: "Questa frase è molto difficile da leggere. Prova a dividerla in frasi più corte o a usare parole più semplici.",
        hard: "Questa frase è difficile da leggere. Considera di semplificarla.",
        veryMonotonous: "Le tue frasi sono molto simili in lunghezza. Varia il ritmo mescolando frasi corte e lunghe.",
        monotonous: "Questa frase è simile a quelle vicine. Prova a variare la lunghezza per migliorare il flusso.",
      },
    },
  },
  inbox: {
    title: "Posta in arrivo",
    message: "Messaggio",
    empty: "Nessuna lettera o commento ancora",
    emptyLetters: "Nessuna lettera ancora",
    emptyComments: "Nessun commento ancora",
    emptyDescription: "Usa questo spazio per vedere le lettere dei tuoi lettori e le conversazioni con gli autori a cui sei iscritto.",
    unread: "Non letti",
    read: "Letti",
    inReplyTo: "In risposta a:",
    writeMessage: "Scrivi un messaggio...",
    submit: "Invia",
    publishing: "Pubblicazione in corso...",
    you: "Tu",
    tabAll: "Tutti",
    tabEmails: "Lettere",
    tabComments: "Commenti",
    typePrivateEmail: "Lettera privata",
    typePublicComment: "Commento pubblico",
    andMore: "e {count} altri",
  },
  comments: {
    title: "Commenti",
    writeComment: "Scrivi un commento...",
    submit: "Pubblica commento",
    publishing: "Pubblicazione in corso...",
    reply: "Rispondi",
    delete: "Elimina",
    deleting: "Eliminazione...",
    deleteConfirm: "Eliminare questo commento?",
    empty: "Ancora nessun commento. Sii il primo a commentare!",
    anonymousParticipant: "Un iscritto",
    flaggedMessage: "Il tuo messaggio è stato segnalato come spam o contenuto inappropriato e non è stato inviato.",
    author: "Autore",
    privateVisibility: "Visibile solo a te e ai partecipanti",
    sendAsPrivate: "Invia come lettera privata",
    translateTo: "Traduci in {locale}",
    showOriginal: "Mostra originale ({locale})",
  },
} satisfies Translation

export default it
